import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUS from './en.json'
import zhCN from './zh.json'

Vue.use(VueI18n)

const messages = {
  'en': enUS,
  'en-US': enUS,
  'zh': zhCN,
  'zh-CN': zhCN,
}

export default new VueI18n({
  locale: navigator.language,
  messages,
})